import { render } from "./NewNav.vue?vue&type=template&id=4ef2c969"
import script from "./NewNav.vue?vue&type=script&lang=js"
export * from "./NewNav.vue?vue&type=script&lang=js"

import "./NewNav.vue?vue&type=style&index=0&id=4ef2c969&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__